<template>
  <div class="main-body">
    <div class="header" >入住老人</div>
    <div class="out">
      <div class="search2">
        <el-button size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" border>

        <el-table-column prop="elderlyName" fixed label="姓名" width="100px"></el-table-column>

        <el-table-column prop="checkinSetmealName" label="护理套餐" width="120px"></el-table-column>

        <el-table-column prop="priceMonth" label="月套餐费用" width="120px"></el-table-column>
        <el-table-column prop="univalenceTrue" label="月实际费用" width="120px"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额"></el-table-column>
        <el-table-column prop="elderlyFund.advance" label="预交金"></el-table-column>
        <el-table-column prop="elderlyFund.imprest" label="备用金"></el-table-column>

        <el-table-column prop="checkinType" label="入住类型" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkinType == '2'" >家庭养老床位</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1'" style="color:blue;">入住中</span>
            <span v-if="scope.row.status == '2'" style="color: gray;">已退住</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" width="180" label="登记时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
             <span v-if="scope.row.status == '1'">
              <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="settlefuc2(scope.$index, scope.row)">退住</el-button>
            </span>
          </template>
        </el-table-column>


      </el-table>

      <div class="page" >
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-bind:arr_ins="arr_ins" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit"
          v-bind:arr_ins="arr_ins" v-on:getList="getList"></Edit>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


    <el-dialog title='退住结算' :visible.sync="settleDialog" class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
      <el-form :model="settleForm" ref="settleForm">
        <el-row>
          <el-col :span="12" class="item">
            <el-form-item label="余额">
              <el-input type="number" v-model="settleForm.elderlyBalance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="item">
            <el-form-item label="扣除金额">
              <el-input type="number" v-model="settleForm.total" placeholder="请输入扣除金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="item">
            <el-form-item label="扣除金额说明">
              <el-input v-model="settleForm.remarks" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settleDialog=false">取 消</el-button>
        <el-button type="primary" :loading="loading2" @click="settleSub('settleForm')">提交</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add2";
import Edit from "./Edit2";
import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn3";

export default {
  name: "Page",
  data() {
    return {
      loading: false,
      loading2: false,

      showModalAdd:false,
      showModalEdit:false,
      showModalGetElderly:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      arr_ins:[],
      institutionCode: '',

      elderlyCode: "",
      userName:'',

      type:2,

      settleDialog:false,
      settleForm: {
        checkinCode:'',
        elderlyBalance:0,
        total: 0,
        remarks: '',
      },

    }
  },

  created() {
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  components: {
    Add,Edit,Elderly
  },
  methods: {


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.institutionCode);
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.userName = '';
    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.type);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit: function (index,row) {
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myEdit.init(row);
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },



    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList() {
      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/GovPage2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          institutionCode:this.institutionCode,
          elderlyCode:this.elderlyCode,
        }
      }).then((response) => {
        //console.log(response);
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    settlefuc2(index,row){

      this.settleForm.total=0;
      this.settleForm.elderlyBalance = row.elderlyFund.balance;
      this.settleForm.remarks = '';
      this.settleForm.checkinCode = row.checkinCode;

      this.settleDialog=true

    },

    settleSub(settleForm){
      this.$refs[settleForm].validate((valid) => {
        if(valid){

          if(this.settleForm.total<0){
            this.$message.info("扣款金额不能小于0");
            return ;
          }
          if(this.settleForm.elderlyBalance<this.settleForm.total){
            this.$message.info("余额不足");
            return ;
          }

          this.loading2 = true;

          this.$axios({
            method: 'post',
            url: this.$shopUrl + "Checkin/RetreatSettle",
            data: {
              timeStr: timeStr,
              sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
              staffCode: getStaffCode(),
              checkinCode:this.settleForm.checkinCode,
              remarks:this.settleForm.remarks,
              total:this.settleForm.total,

              isRefund:2,
              refundMoney:0,

            }
          }).then((response) => {
            //console.log(response);

            this.settleDialog=false
            this.loading2 = false;

            if (response.data.error == 0) {
              this.getList()
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }

          }).catch(function (error) {
            console.log(error);
          });

        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },




  }
}
</script>

<style lang="scss" scoped>

</style>
